import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, ogImage }) => {
  const location = useLocation();
  const baseUrl = 'https://relaxandride.com';
  const fullUrl = `${baseUrl}${location.pathname}`;

  useEffect(() => {
    // Update title
    if (title) {
      document.title = `${title} | RELAX & RIDE - Nassau Bahamas Taxi`;
    }

    // Update meta description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
    }

    // Update meta keywords
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', keywords);
    }

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', fullUrl);
    }

    // Update Open Graph tags
    updateMetaTag('property', 'og:title', title || 'RELAX & RIDE Taxi Service');
    updateMetaTag('property', 'og:description', description || '');
    updateMetaTag('property', 'og:url', fullUrl);
    if (ogImage) {
      updateMetaTag('property', 'og:image', ogImage);
    }
  }, [title, description, keywords, fullUrl, ogImage]);

  return null;
};

const updateMetaTag = (attribute, attributeValue, content) => {
  let element = document.querySelector(`meta[${attribute}="${attributeValue}"]`);
  if (element) {
    element.setAttribute('content', content);
  }
};

export default SEO;
